// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"b59b1bca","326":"fb6d6043","421":"edf31d78","700":"931474d6"}[chunkId] + ".chunk.css";
};